import { StyleSheet } from 'aphrodite';

import { COLORS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export const { pulseAnimation } = StyleSheet.create({
  pulseAnimation: {
    animationName: {
      '0%': {
        opacity: 0.2,
      },
      '50%': {
        opacity: 0.8,
      },
      '100%': {
        opacity: 0.2,
      },
    },
    animationDuration: '1.5s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
  },
});

export default createStyleSheet({
  wrapper: {
    display: 'flex',
    width: '100%',
    padding: 16,
    borderRadius: 12,
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  containerImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 162,
    borderRadius: 4,
    overflow: 'hidden',
    minWidth: 162,
    position: 'relative',
    backgroundColor: COLORS.GREY_MEDIUM.DEFAULT,
  },
  containerInfos: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    marginLeft: 20,
  },
  containerHeader: {
    display: 'flex',
  },
  containerHeaderLeft: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 2,
  },
  typeBar: {
    height: 16,
    width: 80,
    borderRadius: 4,
    backgroundColor: COLORS.GREY_MEDIUM.DEFAULT,
    marginTop: 8,
  },
  titleBar: {
    height: 24,
    width: '70%',
    borderRadius: 4,
    backgroundColor: COLORS.GREY_MEDIUM.DEFAULT,
    marginTop: 12,
  },
  statusBar: {
    height: 18,
    width: 90,
    borderRadius: 9,
    backgroundColor: COLORS.GREY_MEDIUM.DEFAULT,
    marginTop: 12,
  },
  containerFooter: {
    display: 'flex',
    marginTop: 36,
  },
  containerFooterLeft: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 2,
  },
  containerFooterRight: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    flexDirection: 'row-reverse',
  },
  footerBar: {
    height: 16,
    width: 120,
    borderRadius: 4,
    backgroundColor: COLORS.GREY_MEDIUM.DEFAULT,
    marginTop: 8,
  },
  footerBarShort: {
    height: 16,
    width: 90,
    borderRadius: 4,
    backgroundColor: COLORS.GREY_MEDIUM.DEFAULT,
    marginTop: 15,
  },
  flagBar: {
    height: 20,
    width: 30,
    borderRadius: 4,
    backgroundColor: COLORS.GREY_MEDIUM.DEFAULT,
    marginLeft: 8,
  },
});
